module.exports = __webpack_public_path__ + "img/tradestation.556a640e.png";